export default __webpack_public_path__ + "static/media/saviour_statue_icon.b73e5499.png";